var Tabs = function(options) {
  var self = this;
  this.toggle = {
    'elements' : document.body.getElementsByClassName(options.toggle),
    'selector': options.toggle,
    'active'  : options.toggle + '--active'
  };
  this.tab = {
    'elements' : document.body.getElementsByClassName(options.tab),
    'selector': options.tab,
    'active'  : options.tab + '--active'
  };

  this.init = function() {
    var clicked = false;
    $(self.toggle.elements).on('click', function(){
      if ($(this).hasClass(self.toggle.active)) {
        self.closeTab(this);
      } else {
        self.openTab(this);
      };
    });
  };

  this.openTab = function(toggle) {
    var currToggle = $(toggle);
    var currTab = self.getTarget(currToggle);
    $('.'+self.toggle.selector).not(currToggle).removeClass(self.toggle.active).attr('aria-expanded', 'false');
    $('.'+self.tab.selector).not(currTab).removeClass(self.tab.active).attr('aria-hidden', 'true');
    currToggle.addClass(self.toggle.active).attr('aria-expanded', 'true');
    currTab.addClass(self.tab.active).attr('aria-hidden', 'false');
  };

  this.closeTab = function(toggle) {
    var currToggle = $(toggle);
    var tab = self.getTarget(currToggle);
    currToggle.removeClass(self.toggle.active).attr('aria-expanded', 'false');
    tab.removeClass(self.tab.active).attr('aria-hidden', 'true');
  };

  this.getTarget = function(element) {
    return $('.' + self.tab.selector+'[data-tab='+element.data('target')+']');
  };

  this.init();
};
